import { data } from "react-router-dom";

type Field = {
  id?: string | number;
  name: string | number;
  title: string;
  type: "text" | "radio" | "select";
  options?: Array<string | { id: string | number; name: string }>;
  dataType?: "number" | "string";
  nestedFields?: Field[];
  showIf?: { field: string | number; value: any };
  validation?: {
    min?: number;
    max?: number;
    message?: string;
  };
};

type Section = {
  title: string;
  fields: any[];
};

// for retail

export const SelectAmenityCategoryRetail = [
  {
    id: 1,
    name: "Urban Reach",
  },
  {
    id: 2,
    name: "Rural Reach",
  },
  {
    id: 3,
    name: "Hilly / Mountainous Reach",
  },
];

//For Private

export const SelectAmenityCategoryPrivate = [
  {
    id: 1,
    name: "Urban Reach",
  },
  {
    id: 2,
    name: "Rural Reach",
  },
];

export const isServiceRoadProvideNodData = [
  {
    title:
      "Is this facility constructed without any prior access permission from the State/UT authority?",
    name: "is_constructed_without_prior_permission",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title: "Is the facility energized or in operation without access?",
    name: "is_facility_operational",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title: "Is this a part of a Rest Area Complex?",
    name: "is_part_of_rest_area",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export const notPreviouslyApproved = [
  {
    title:
      "Whether service road/slip road already exists at the proposed location? *",
    name: "is_service_road_provided",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title:
      "Whether the retail outlet is on the service road/slip road (and not on the entry/exit ramp of the service road/slip road)?",
    name: "on_slip_road",
    type: "radio",
    options: ["Yes", "No"],
    showIf: {
      field: "is_service_road_provided",
      value: "Yes",
    },
  },
  {
    title:
      "Whether the retail outlet satisfies the general conditions of siting, access conditions, drainage, building line, signboards, etc., depending upon road availability?",
    name: "access_criteria_met",
    type: "radio",
    options: ["Yes", "No"],
    showIf: {
      field: "is_service_road_provided",
      value: "Yes",
    },
  },
  {
    title:
      "Fuel Station / Wayside Amenity is existing on a road developed earlier but newly notified as National Highway without any access permission from the competent authority in the State/UT concerned, even after the date of notification?",
    name: "is_constructed_without_prior_permission",
    type: "radio",
    options: ["Yes", "No"],
    // showIf: {
    //   field: "is_service_road_provided",
    //   value: "No",
    // },
  },
  {
    title:
      "Energized fuel stations / commercial operations of a Wayside Amenity that fulfill the prescribed norms are being carried out without obtaining prior permission for grant of access from the Highway Administrator?",
    name: "is_facility_operational",
    type: "radio",
    options: ["Yes", "No"],
    // showIf: {
    //   field: "is_service_road_provided",
    //   value: "No",
    // },
  },
];

export const notPreviouslyApprovedSeekClarification = [
  {
    title:
      "Whether service road/slip road already exists at the proposed location? *",
    name: "is_service_road_provided",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title:
      "Whether the retail outlet is on the service road/slip road (and not on the entry/exit ramp of the service road/slip road)?",
    name: "on_slip_road",
    type: "radio",
    options: ["Yes", "No"],
    showIf: {
      field: "is_service_road_provided",
      value: "Yes",
    },
  },
  {
    title:
      "Whether the retail outlet satisfies the general conditions of siting, access conditions, drainage, building line, signboards, etc., depending upon road availability?",
    name: "access_criteria_met",
    type: "radio",
    options: ["Yes", "No"],
    showIf: {
      field: "is_service_road_provided",
      value: "Yes",
    },
  },
];

export const SelectServiceRoadTypePrivate = [
  { id: 1, name: "Existing Slip Road / Service Road" },
  { id: 2, name: "Common Service Road" },
  { id: 3, name: "No Service Road" },
];

export const ifExistingSlipRoad: Field[] = [
  {
    name: "is_located_on_service_road",
    title:
      "Whether the private property is on the service/slip road (and not on the entry/exit ramp of the service/slip road):",
    type: "radio",
    options: ["Yes", "No"],
    showIf: {
      field: "service_road_type_id",
      value: 1,
    },
  },
  {
    name: "meets_general_access_requirements",
    title:
      "Whether the private property satisfies the general conditions of access, drainage, building lines, sign boards, etc., depending on the availability of the land:",
    type: "radio",
    options: ["Yes", "No"],
    showIf: {
      field: "service_road_type_id",
      value: 1,
    },
  },
  {
    name: "total_traffic_per_day",
    title: "Total traffic (incoming and outgoing) per day.",
    type: "text",
    dataType: "number",
    showIf: {
      field: "service_road_type_id",
      value: 1,
    },
  },
];

// NO Service

export const ifUrbanSectionPrivateNoServiceNew: Section[] = [
  {
    title: "Distance Norms ",
    fields: [
      {
        name: 104,
        id: 104,
        title:
          "Is the minimum distance between merging points of a service road (including acceleration and deceleration lanes of 100 m and 70 m respectively) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the distance between merging points of service road (in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 105,
        name: 105,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_carriageway",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway (in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 106,
        name: 106,
        title:
          "Is the distance between the take-off point of access/service road and the median gap or intersection ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between take-off point of access/service road and the median gap or intersection(in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 304,
        name: 304,
        title:
          "Whether minimum distance from check barrier is at least 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "check_barrier_distance",
            title: "Please specify the distance from Check Barrier.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 107,
        name: 107,
        title:
          "Is the distance from the start of ROB / flyover / grade separator / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing(in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Access Road & Turning Requirements",
    fields: [
      {
        id: 108,
        name: 108,
        title:
          "Is the width of the entrance/exit between 9 metres (min) and 12 metres (max)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of entrance/exit(in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 109,
        name: 109,
        title:
          "Is the radius of the turning curve at least 13 metres (ruling radius: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title:
              "Please specify the radius of the turning curve (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 110,
        name: 110,
        title:
          "Is the radius of the non-turning curve between 1.5 metres and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title:
              "Please specify the radius of non-turning curve (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Service Road & Lane Dimensions",
    fields: [
      {
        id: 111,
        name: 111,
        title: "Is the width of the acceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title:
              "Please specify the width of the acceleration lane(in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 112,
        name: 112,
        title: "Is the width of the deceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title:
              "Please specify the width of the deceleration lane(in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 113,
        name: 113,
        title:
          "Is the width of the service road between 5.5 metres and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Compliance & Road Markings",
    fields: [
      {
        id: 305,
        name: 305,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        // alwaysShowNested: true,
        // nestedFields: [
        //   {
        //     name: "service_road_length",
        //     title: "Please specify the length of the service road (in metres)",
        //     type: "text",
        //     dataType: "number",
        //   },
        // ],
      },
      {
        id: 306,
        name: 306,
        title:
          "Crust composition of access connection/extended service road to residential properties (at least gravel road)?",
        options: ["Yes", "No"],
        type: "radio",
        // alwaysShowNested: true,
        // nestedFields: [
        //   {
        //     name: "access_connection_crust_composition",
        //     title: "Please specify the width provided (in metres).",
        //     type: "text",
        //   },
        // ],
      },
      {
        id: 307,
        name: 307,
        title:
          "Width of access connection/extended service road to residential properties (minimum 3.5 m).",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width provided (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 3.5,
            },
          },
        ],
      },
      {
        id: 308,
        name: 308,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 114,
        name: 114,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35? ",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Culvert Compliance",
    fields: [
      {
        id: 115,
        name: 115,
        title: "Is a for culvert drainage provided as per IRC:SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 116,
        name: 116,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 117,
        name: 117,
        title: "Is the downward slope of the access road ≥ 2%?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the downward slope of the access road (in percentage).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 316,
        name: 316,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

export const ifRuralSectionPrivateNoServiceNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 118,
        name: 118,
        title:
          "Is the distance between merging points of service roads including acceleration/deceleration lanes (limited to plot size + 50 m on either side + lanes) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the minimum distance between merging points of a service road (including acceleration and deceleration lanes.",
            type: "text",
            dataType: "string",
            validation: {
              min: 50,
            },
          },
        ],
      },
      {
        id: 119,
        name: 119,
        title:
          "Is the distance between two access roads on the same side ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_side",
            title:
              "Please specify the distance between two access roads on the same side.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 120,
        name: 120,
        title:
          "Is the distance between the access take-off point and nearest intersection/median gap ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between the take-off point of access/service road and the median gap or intersection.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 309,
        name: 309,
        title:
          "Whether minimum distance from check barrier is at least 1000 m?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "check_barrier_distance",
            title: "Please specify the distance from Check Barrier.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
            },
          },
        ],
      },
      {
        id: 121,
        name: 121,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from start of ROB / flyover / grade separator / Railway Level Crossing).",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Dimensions & Geometry",
    fields: [
      {
        id: 122,
        name: 122,
        title:
          "Is the width of the entrance/exit between 9 metres and 12 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of the entrance/exit.",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 123,
        name: 123,
        title: "Is the radius of the turning curve ≥ 13 metres (ruling: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the radius of the turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 124,
        name: 124,
        title:
          "Is the radius of the non-turning curve between 1.5 and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the radius of the non-turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Lanes & Road Width",
    fields: [
      {
        id: 125,
        name: 125,
        title: "Is the width of the acceleration lanes ≥ 5.5 metres each?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title: "Please specify the width of the acceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 310,
        name: 310,
        title: "Is the width of the deceleration lane ≥ 5.5 metres? ",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title: "Please specify the width of the deceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 126,
        name: 126,
        title: "Is the width of the service road between 5.5 and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Material Compliance",
    fields: [
      {
        id: 127,
        name: 127,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        // nestedFields: [
        //   {
        //     name: "service_road_length",
        //     title: "Please Specify the width provided (in metres)",
        //     type: "text",
        //     dataType: "number",
        //   },
        // ],
      },
      {
        id: 311,
        name: 311,
        title:
          "Crust composition of access connection/extended service road to residential properties (at least gravel road)",
        options: ["Yes", "No"],
        type: "radio",
        // alwaysShowNested: true,
        // nestedFields: [
        //   {
        //     name: "access_connection_crust_composition",
        //     title: "Please specify the Crust Composition",
        //     type: "text",
        //   },
        // ],
      },
      {
        id: 312,
        name: 312,
        title:
          "Width of access connection/extended service road to residential properties (minimum 3.5 m)",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title:
              "Please specify the width of Acces Connection/ extended service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 3.5,
            },
          },
        ],
      },
      {
        id: 128,
        name: 128,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35?",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Environmental Measures",
    fields: [
      {
        id: 129,
        name: 129,
        title: "Is a culvert provided and designed as per IRC: SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 130,
        name: 130,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 131,
        name: 131,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title: "Please specify the downward slope of the access road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 317,
        name: 317,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

// Common Service Road

export const ifUrbanSectionPrivateCommonNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        name: 318,
        id: 318,
        title:
          "Is the minimum distance between merging points of a service road (including acceleration and deceleration lanes of 100 m and 70 m respectively) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the distance between merging points of service road.",
            type: "text",
            dataType: "string",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 319,
        name: 319,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_carriageway",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 320,
        name: 320,
        title:
          "Is the distance between the take-off point of access/service road and the median gap or intersection ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between take-off point of access/service road and the median gap or intersection.",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 321,
        name: 321,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Access Road & Turning Requirements",
    fields: [
      {
        id: 322,
        name: 322,
        title:
          "Is the width of the entrance/exit between 9 metres (min) and 12 metres (max)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of entrance/exit.",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 323,
        name: 323,
        title:
          "Is the radius of the turning curve at least 13 metres (ruling radius: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the radius of the turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 324,
        name: 324,
        title:
          "Is the radius of the non-turning curve between 1.5 metres and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the radius of non-turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Service Road & Lane Dimensions",
    fields: [
      {
        id: 325,
        name: 325,
        title: "Is the width of the acceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title: "Please specify the width of the acceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 326,
        name: 326,
        title: "Is the width of the deceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title: "Please specify the width of the deceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 327,
        name: 327,
        title:
          "Is the width of the service road between 5.5 metres and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Markings Compliance",
    fields: [
      {
        id: 328,
        name: 328,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        // nestedFields: [
        //   {
        //     name: "service_road_length",
        //     title: "Specify the width provided (in metres)",
        //     type: "text",
        //     dataType: "number",
        //   },
        // ],
      },
      {
        id: 329,
        name: 329,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 330,
        name: 330,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35?",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Culvert Compliance",
    fields: [
      {
        id: 331,
        name: 331,
        title: "Is a culvert provided and designed as per IRC: SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 332,
        name: 332,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 333,
        name: 333,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the access road slope towards the intercepting drain.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 334,
        name: 334,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

export const ifRuralSectionPrivateCommonNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 335,
        name: 335,
        title:
          "Is the distance between merging points of service roads including acceleration/deceleration lanes (limited to plot size + 50 m on either side + lanes) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify distance between merging points of service roads including acceleration/deceleration lanes.",
            type: "text",
            dataType: "string",
            validation: {
              min: 50,
            },
          },
        ],
      },
      {
        id: 336,
        name: 336,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_side",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 337,
        name: 337,
        title:
          "Is the distance between the access take-off point and nearest intersection/median gap ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between access take-off point and nearest intersection/median gap.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 338,
        name: 338,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres? ",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Dimensions & Geometry",
    fields: [
      {
        id: 339,
        name: 339,
        title:
          "Is the width of the entrance/exit between 9 metres and 12 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of the entrance/exit.",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 340,
        name: 340,
        title: "Is the radius of the turning curve ≥ 13 metres (ruling: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the radius of the turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 341,
        name: 341,
        title:
          "Is the radius of the non-turning curve between 1.5 and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the radius of the non-turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Lanes & Road Width",
    fields: [
      {
        id: 342,
        name: 342,
        title: "Is the width of the acceleration lanes ≥ 5.5 metres each?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title: "Please specify the width of the acceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 343,
        name: 343,
        title: "Is the width of the deceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title: "Please specify the width of the deceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 344,
        name: 344,
        title:
          "Is the width of the service road between 5.5 metres and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Material Compliance",
    fields: [
      {
        id: 352,
        name: 352,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        // nestedFields: [
        //   {
        //     name: "service_road_length",
        //     title: "Specify the width provided (in metres)",
        //     type: "text",
        //     dataType: "number",
        //   },
        // ],
      },
      {
        id: 345,
        name: 345,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 346,
        name: 346,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35?",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Environmental Measures",
    fields: [
      {
        id: 347,
        name: 347,
        title: "Is a culvert provided and designed as per IRC: SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 348,
        name: 348,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 349,
        name: 349,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the access road slope towards the intercepting drain.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 350,
        name: 350,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

// private

// Residential Properties

// NO Service Road:

export const ifResidentialUrbanSectionPrivateNoServiceNew: Section[] = [
  {
    title: "Distance Norms ",
    fields: [
      {
        name: 104,
        id: 104,
        title:
          "Is the minimum distance between merging points of a service road (including acceleration and deceleration lanes of 100 m and 70 m respectively) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the distance between merging points of service road (in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 105,
        name: 105,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_carriageway",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway (in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 106,
        name: 106,
        title:
          "Is the distance between the take-off point of access/service road and the median gap or intersection ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between take-off point of access/service road and the median gap or intersection(in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 304,
        name: 304,
        title:
          "Whether minimum distance from check barrier is at least 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "check_barrier_distance",
            title: "Please specify the distance from Check Barrier.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 107,
        name: 107,
        title:
          "Is the distance from the start of ROB / flyover / grade separator / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing(in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Compliance & Road Markings",
    fields: [
      {
        id: 306,
        name: 306,
        title:
          "Crust composition of access connection/extended service road to residential properties (at least gravel road)?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 307,
        name: 307,
        title:
          "Width of access connection/extended service road to residential properties (minimum 3.5 m).",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width provided (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 3.5,
            },
          },
        ],
      },
      {
        id: 109,
        name: 109,
        title:
          "Is the radius of the turning curve at least 13 metres (ruling radius: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title:
              "Please specify the radius of the turning curve (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Drainage & Culvert Compliance",
    fields: [
      {
        id: 116,
        name: 116,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 117,
        name: 117,
        title: "Is the downward slope of the access road ≥ 2%?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the downward slope of the access road (in percentage).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 316,
        name: 316,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

export const ifResidentialRuralSectionPrivateNoServiceNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 118,
        name: 118,
        title:
          "Is the distance between merging points of service roads including acceleration/deceleration lanes (limited to plot size + 50 m on either side + lanes) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the minimum distance between merging points of a service road (including acceleration and deceleration lanes.",
            type: "text",
            dataType: "string",
            validation: {
              min: 50,
            },
          },
        ],
      },
      {
        id: 119,
        name: 119,
        title:
          "Is the distance between two access roads on the same side ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_side",
            title:
              "Please specify the distance between two access roads on the same side.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 120,
        name: 120,
        title:
          "Is the distance between the access take-off point and nearest intersection/median gap ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between the take-off point of access/service road and the median gap or intersection.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 309,
        name: 309,
        title:
          "Whether minimum distance from check barrier is at least 1000 m?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "check_barrier_distance",
            title: "Please specify the distance from Check Barrier.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
            },
          },
        ],
      },
      {
        id: 121,
        name: 121,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from start of ROB / flyover / grade separator / Railway Level Crossing).",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Material Compliance",
    fields: [
      {
        id: 311,
        name: 311,
        title:
          "Crust composition of access connection/extended service road to residential properties (at least gravel road)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 312,
        name: 312,
        title:
          "Width of access connection/extended service road to residential properties (minimum 3.5 m)",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title:
              "Please specify the width of Acces Connection/ extended service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 3.5,
            },
          },
        ],
      },
      {
        id: 109,
        name: 109,
        title:
          "Is the radius of the turning curve at least 13 metres (ruling radius: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title:
              "Please specify the radius of the turning curve (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Drainage & Environmental Measures",
    fields: [
      {
        id: 130,
        name: 130,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 131,
        name: 131,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title: "Please specify the downward slope of the access road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 317,
        name: 317,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

//Common Service Road:

export const ifResidentialUrbanSectionPrivateCommonNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        name: 318,
        id: 318,
        title:
          "Is the minimum distance between merging points of a service road (including acceleration and deceleration lanes of 100 m and 70 m respectively) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the distance between merging points of service road.",
            type: "text",
            dataType: "string",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 319,
        name: 319,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_carriageway",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 320,
        name: 320,
        title:
          "Is the distance between the take-off point of access/service road and the median gap or intersection ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between take-off point of access/service road and the median gap or intersection.",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 321,
        name: 321,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Drainage & Culvert Compliance",
    fields: [
      {
        id: 332,
        name: 332,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 333,
        name: 333,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the access road slope towards the intercepting drain.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 334,
        name: 334,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

export const ifResidentialRuralSectionPrivateCommonNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 335,
        name: 335,
        title:
          "Is the distance between merging points of service roads including acceleration/deceleration lanes (limited to plot size + 50 m on either side + lanes) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify distance between merging points of service roads including acceleration/deceleration lanes.",
            type: "text",
            dataType: "string",
            validation: {
              min: 50,
            },
          },
        ],
      },
      {
        id: 336,
        name: 336,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_side",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 337,
        name: 337,
        title:
          "Is the distance between the access take-off point and nearest intersection/median gap ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between access take-off point and nearest intersection/median gap.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 338,
        name: 338,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres? ",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Drainage & Environmental Measures",
    fields: [
      {
        id: 348,
        name: 348,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 349,
        name: 349,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the access road slope towards the intercepting drain.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 350,
        name: 350,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

// Other Properties

// NO Service Road:

export const ifOtherUrbanSectionPrivateNoServiceNew: Section[] = [
  {
    title: "Distance Norms ",
    fields: [
      {
        name: 104,
        id: 104,
        title:
          "Is the minimum distance between merging points of a service road (including acceleration and deceleration lanes of 100 m and 70 m respectively) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the distance between merging points of service road (in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 105,
        name: 105,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_carriageway",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway (in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 106,
        name: 106,
        title:
          "Is the distance between the take-off point of access/service road and the median gap or intersection ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between take-off point of access/service road and the median gap or intersection(in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 304,
        name: 304,
        title:
          "Whether minimum distance from check barrier is at least 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "check_barrier_distance",
            title: "Please specify the distance from Check Barrier.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 107,
        name: 107,
        title:
          "Is the distance from the start of ROB / flyover / grade separator / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing(in metres).",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Access Road & Turning Requirements",
    fields: [
      {
        id: 108,
        name: 108,
        title:
          "Is the width of the entrance/exit between 9 metres (min) and 12 metres (max)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of entrance/exit(in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 109,
        name: 109,
        title:
          "Is the radius of the turning curve at least 13 metres (ruling radius: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title:
              "Please specify the radius of the turning curve (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 110,
        name: 110,
        title:
          "Is the radius of the non-turning curve between 1.5 metres and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title:
              "Please specify the radius of non-turning curve (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Service Road & Lane Dimensions",
    fields: [
      {
        id: 111,
        name: 111,
        title: "Is the width of the acceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title:
              "Please specify the width of the acceleration lane(in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 112,
        name: 112,
        title: "Is the width of the deceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title:
              "Please specify the width of the deceleration lane(in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 113,
        name: 113,
        title:
          "Is the width of the service road between 5.5 metres and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Compliance & Road Markings",
    fields: [
      {
        id: 305,
        name: 305,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 308,
        name: 308,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 114,
        name: 114,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35? ",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Culvert Compliance",
    fields: [
      {
        id: 115,
        name: 115,
        title: "Is a for culvert drainage provided as per IRC:SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 116,
        name: 116,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 117,
        name: 117,
        title: "Is the downward slope of the access road ≥ 2%?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the downward slope of the access road (in percentage).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 316,
        name: 316,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

export const ifOtherRuralSectionPrivateNoServiceNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 118,
        name: 118,
        title:
          "Is the distance between merging points of service roads including acceleration/deceleration lanes (limited to plot size + 50 m on either side + lanes) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the minimum distance between merging points of a service road (including acceleration and deceleration lanes.",
            type: "text",
            dataType: "string",
            validation: {
              min: 50,
            },
          },
        ],
      },
      {
        id: 119,
        name: 119,
        title:
          "Is the distance between two access roads on the same side ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_side",
            title:
              "Please specify the distance between two access roads on the same side.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 120,
        name: 120,
        title:
          "Is the distance between the access take-off point and nearest intersection/median gap ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between the take-off point of access/service road and the median gap or intersection.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 309,
        name: 309,
        title:
          "Whether minimum distance from check barrier is at least 1000 m?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "check_barrier_distance",
            title: "Please specify the distance from Check Barrier.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
            },
          },
        ],
      },
      {
        id: 121,
        name: 121,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from start of ROB / flyover / grade separator / Railway Level Crossing).",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Dimensions & Geometry",
    fields: [
      {
        id: 122,
        name: 122,
        title:
          "Is the width of the entrance/exit between 9 metres and 12 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of the entrance/exit.",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 123,
        name: 123,
        title: "Is the radius of the turning curve ≥ 13 metres (ruling: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the radius of the turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 124,
        name: 124,
        title:
          "Is the radius of the non-turning curve between 1.5 and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the radius of the non-turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Lanes & Road Width",
    fields: [
      {
        id: 125,
        name: 125,
        title: "Is the width of the acceleration lanes ≥ 5.5 metres each?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title: "Please specify the width of the acceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 310,
        name: 310,
        title: "Is the width of the deceleration lane ≥ 5.5 metres? ",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title: "Please specify the width of the deceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 126,
        name: 126,
        title: "Is the width of the service road between 5.5 and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Material Compliance",
    fields: [
      {
        id: 127,
        name: 127,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
      },
      {
        id: 128,
        name: 128,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 308,
        name: 308,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Environmental Measures",
    fields: [
      {
        id: 129,
        name: 129,
        title: "Is a culvert provided and designed as per IRC: SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 130,
        name: 130,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 131,
        name: 131,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title: "Please specify the downward slope of the access road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 317,
        name: 317,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

//Common Service Road:

export const ifOtherUrbanSectionPrivateCommonNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        name: 318,
        id: 318,
        title:
          "Is the minimum distance between merging points of a service road (including acceleration and deceleration lanes of 100 m and 70 m respectively) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify the distance between merging points of service road.",
            type: "text",
            dataType: "string",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 319,
        name: 319,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_carriageway",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 320,
        name: 320,
        title:
          "Is the distance between the take-off point of access/service road and the median gap or intersection ≥ 100 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between take-off point of access/service road and the median gap or intersection.",
            type: "text",
            dataType: "string",
            validation: {
              min: 100,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 321,
        name: 321,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Access Road & Turning Requirements",
    fields: [
      {
        id: 322,
        name: 322,
        title:
          "Is the width of the entrance/exit between 9 metres (min) and 12 metres (max)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of entrance/exit.",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 323,
        name: 323,
        title:
          "Is the radius of the turning curve at least 13 metres (ruling radius: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the radius of the turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 324,
        name: 324,
        title:
          "Is the radius of the non-turning curve between 1.5 metres and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the radius of non-turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Service Road & Lane Dimensions",
    fields: [
      {
        id: 325,
        name: 325,
        title: "Is the width of the acceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title: "Please specify the width of the acceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 326,
        name: 326,
        title: "Is the width of the deceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title: "Please specify the width of the deceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 327,
        name: 327,
        title:
          "Is the width of the service road between 5.5 metres and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Markings Compliance",
    fields: [
      {
        id: 328,
        name: 328,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
      },
      {
        id: 329,
        name: 329,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 330,
        name: 330,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35?",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Culvert Compliance",
    fields: [
      {
        id: 331,
        name: 331,
        title: "Is a culvert provided and designed as per IRC: SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 332,
        name: 332,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 333,
        name: 333,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the access road slope towards the intercepting drain.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 334,
        name: 334,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

export const ifOtherRuralSectionPrivateCommonNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 335,
        name: 335,
        title:
          "Is the distance between merging points of service roads including acceleration/deceleration lanes (limited to plot size + 50 m on either side + lanes) maintained?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "min_service_road_merging_distance_m",
            title:
              "Please specify distance between merging points of service roads including acceleration/deceleration lanes.",
            type: "text",
            dataType: "string",
            validation: {
              min: 50,
            },
          },
        ],
      },
      {
        id: 336,
        name: 336,
        title:
          "Is the distance between two access roads (merging/take-off points) on the same carriageway ≥ 1000 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_road_same_side",
            title:
              "Please specify the distance between two access roads (merging/take-off points) on the same carriageway.",
            type: "text",
            dataType: "string",
            validation: {
              min: 1000,
              // message: "Distance must be at least 100 metres",
            },
          },
        ],
      },
      {
        id: 337,
        name: 337,
        title:
          "Is the distance between the access take-off point and nearest intersection/median gap ≥ 300 meters?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_between_access_roads_m",
            title:
              "Please specify the distance between access take-off point and nearest intersection/median gap.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 338,
        name: 338,
        title:
          "Is the distance from the start of ROB / flyover / Railway Level Crossing ≥ 300 metres? ",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_rob_flyover_m",
            title:
              "Please specify the distance from the start of ROB / flyover / Railway Level Crossing.",
            type: "text",
            dataType: "string",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Dimensions & Geometry",
    fields: [
      {
        id: 339,
        name: 339,
        title:
          "Is the width of the entrance/exit between 9 metres and 12 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "entrance_or_exit_width",
            title: "Please specify the width of the entrance/exit.",
            type: "text",
            dataType: "number",
            validation: {
              min: 9,
              max: 12,
            },
          },
        ],
      },
      {
        id: 340,
        name: 340,
        title: "Is the radius of the turning curve ≥ 13 metres (ruling: 30 m)?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the radius of the turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 341,
        name: 341,
        title:
          "Is the radius of the non-turning curve between 1.5 and 3 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the radius of the non-turning curve.",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Lanes & Road Width",
    fields: [
      {
        id: 342,
        name: 342,
        title: "Is the width of the acceleration lanes ≥ 5.5 metres each?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_width",
            title: "Please specify the width of the acceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 343,
        name: 343,
        title: "Is the width of the deceleration lane ≥ 5.5 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_width",
            title: "Please specify the width of the deceleration lane.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
            },
          },
        ],
      },
      {
        id: 344,
        name: 344,
        title:
          "Is the width of the service road between 5.5 metres and 7.0 metres?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title: "Please specify the width of the service road.",
            type: "text",
            dataType: "number",
            validation: {
              min: 5.5,
              max: 7,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Construction & Material Compliance",
    fields: [
      {
        id: 352,
        name: 352,
        title:
          "Is the service road acceleration and deceleration lane constructed with a minimum of 150 mm GSB, three 75 mm WBM layers (excluding WBM Grading No. 1), 50 mm BM, 30 mm BC, or alternatively with Interlocking Concrete Blocks as per IRC: SP:63?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
      },
      {
        id: 345,
        name: 345,
        title:
          "Road signs are to be provided as per IRC:67 such as Side Road sign on NH before deceleration lane, appropriate facility information sign (e.g., hospital, eating space etc.), one-way signs on the left side of deceleration and acceleration lanes, No Parking sign on the left side of deceleration and acceleration lanes, No Entry sign on the right side of the deceleration lane at its connection with the service road, appropriate number of right-turn prohibited signs on the right side of the service road in front of the property plot, Give Way sign with Give Way line marking according to IRC:35 on the left side of the acceleration lane at 30 m before its connection with NH, No Left Turn sign on NH before its connection with the acceleration lane, No Right Turn sign on the right side of NH in case of an undivided carriageway.",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 346,
        name: 346,
        title:
          "Are the markings on deceleration and acceleration lanes compliant with IRC:35?",
        options: ["Yes", "No"],
        type: "radio",
      },
    ],
  },
  {
    title: "Drainage & Environmental Measures",
    fields: [
      {
        id: 347,
        name: 347,
        title: "Is a culvert provided and designed as per IRC: SP-13?",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 348,
        name: 348,
        title:
          "Provision for intercepting drain with vertical drain system for rainwater harvesting at the downstream end of the intercepting drain (according to Appendix A-2 of IRC:SP:50)",
        options: ["Yes", "No"],
        type: "radio",
      },
      {
        id: 349,
        name: 349,
        title: "Is the access road slope ≥ 2% towards the intercepting drain?",
        options: ["Yes", "No"],
        type: "radio",
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the access road slope towards the intercepting drain.",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Traffic Details",
    fields: [
      {
        id: 350,
        name: 350,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        name: "total_traffic_per_day",
        title: "Total traffic (incoming and outgoing) per day.",
        type: "text",
        dataType: "number",
      },
    ],
  },
];

// for reatil or Fuel Station

export const ifUrbanSectionRetailNew: Section[] = [
  {
    title: "Location-Based Distance Criteria",
    fields: [
      {
        id: 1,
        name: 1,
        title:
          "Is the distance from the nearest intersection (any category / road median gap) at least 100 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_nearest_intersection",
            title:
              "Please specify the distance from the nearest intersection (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 100,
            },
          },
        ],
      },
      {
        id: 287,
        name: 287,
        title:
          "Is the distance from the nearest toll plaza, railway level crossing, or check barrier at least 1000 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_toll_plaza",
            title:
              "Please specify the distance from the nearest toll plaza (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1000,
              // message: "Distance must be at least 1000 metres",
            },
          },
        ],
      },
      {
        id: 2,
        name: 2,
        title:
          "Is the distance from the start of the Road Over Bridge (ROB) at least 200 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_start_rob",
            title:
              "Please specify the distance from the start of the Road Over Bridge (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 200,
              // message: "Distance must be at least 200 metres",
            },
          },
        ],
      },
      {
        id: 3,
        name: 3,
        title:
          "Is the distance from the start of the flyover / grade separator at least 300 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "start_distance_from_flyover",
            title:
              "Please specify the distance from the start of the flyover / grade separator (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
      {
        name: "fuel_station_carriageway_type",
        title:
          "Nature of Carriageway",
        type: "radio",
        options: [
          { id: "Yes", name: "Undivided Carriageway" },
          { id: "No", name: "Divided Carriageway" },
        ],
      },
      {
        id: 77,
        name: 77,
        title:
          "Distance from nearest Fuel Station Undivided carriageway (for both side of carriageway) is 300 m ? Note: However, this restriction shall not apply in case access / egress for all such fuel stations are provided through common service road of 7.0 m width and not directly through NH. Further, access for fuel stations at closer proximity than 300 m may be allowed provided entry / exit for both the fuel stations are provided through a service road of 7.0 m width having sufficient length; further, additional length of such service road shall be constructed at the cost of the latter fuel station owner / company seeking grant of permission for access for the facility",
        type: "radio",
        options: ["Yes", "No"],
        showIf: {
          field: "fuel_station_carriageway_type",
          value: "Yes",
        },
        nestedFields: [
          {
            name: "carriageway_fs_distance",
            title:
              "Please specify the undivided carriageway distance from fuel station (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 432,
        name: 432,
        title:
          "Distance from nearest Fuel Station Divided carriageway (with no gap in median at this location) is 300 m ? Note: However, this restriction shall not apply in case access / egress for all such fuel stations are provided through common service road of 7.0 m width and not directly through NH. Further, access for fuel stations at closer proximity than 300 m may be allowed provided entry / exit for both the fuel stations are provided through a service road of 7.0 m width having sufficient length; further, additional length of such service road shall be constructed at the cost of the latter fuel station owner / company seeking grant of permission for access for the facility.",
        type: "radio",
        options: ["Yes", "No"],
        showIf: {
          field: "fuel_station_carriageway_type",
          value: "No",
        },
        nestedFields: [
          {
            name: "divided_carriageway_distance_from_fs",
            title:
              "Please specify the divided carriageway distance from fuel station (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Access Road & Service Road Requirements",
    fields: [
      {
        id: 6,
        name: 6,
        title:
          "Is there a provision of a service/connecting road provided near the property (necessary at clustering of retail outlets/intersections with any category of road less than 300 m)?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_width",
            title:
              "What is the length of the service road including deceleration and acceleration lanes (in metres)?",
            type: "text",
            dataType: "number",
          },
          {
            id: 8,
            name: 8,
            title:
              "Whether additional land acquisition is required for service road/turning radius?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                name: "land_acquired_extent",
                title:
                  "Mention the extent of land acquisition required (in sq.m).",
                type: "text",
                dataType: "number",
                showIf: {
                  field: 8,
                  value: "Yes",
                },
              },
            ],
          },
        ],
      },
      {
        id: 9,
        name: 9,
        title:
          "Whether additional land acquisition as above has been done by the oil company?",
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            id: 10,
            name: 10,
            title:
              "Whether documentary evidence of land acquisition details is attached?",
            type: "radio",
            options: ["Yes", "No"],
            showIf: {
              field: 9,
              value: "Yes",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Road and Site Gradient/Level Compliance",
    fields: [
      {
        id: 11,
        name: 11,
        title: "Is the gradient of the highway section ≤ 5%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "highway_gradient_section",
            title: "Please specify the gradient of the highway section (in %).",
            type: "text",
            dataType: "number",
            validation: {
              max: 5,
            },
          },
        ],
      },
      {
        id: 290,
        name: 290,
        title:
          "Is the slope of the fuel station premises/service area for drainage purposes ≥ 2%? ",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "fuel_station_slope_percentage",
            title:
              "Please specify the downward slope of the access road (in %).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Buffer Strip and Road Element Dimensions",
    fields: [
      {
        id: 12,
        name: 12,
        title: "Is the length of the buffer strip ≥ 5 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "buffer_strip_length",
            title: "Please specify the buffer strip length (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 5,
            },
          },
        ],
      },
      {
        id: 13,
        name: 13,
        title: "Is the width of the buffer strip inside the ROW ≥ 3 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "buffer_strip_width",
            title: "Please specify the buffer strip width (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 3,
            },
          },
        ],
      },
      {
        id: 14,
        name: 14,
        title: "Is the height of the kerb ≥ 275 mm?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "kerb_height",
            title: "Please specify the kerb height (in mm).",
            type: "text",
            dataType: "number",
            validation: {
              min: 275,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Turning Radius and Access Curve Requirements",
    fields: [
      {
        id: 15,
        name: 15,
        title: "Is the radius of the turning curve ≥ 13 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the turning curve radius (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 16,
        name: 16,
        title:
          "Is the radius of the non-turning curve between 1.5 metres and 3 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the non-turning curve radius (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
          {
            id: 135,
            name: 135,
            title:
              "Whether land acquisition is required by the side of the ROW (to provide the prescribed turning radius) by the owner of the fuel station? ",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                name: "area_acquired",
                title:
                  "Mention additional land acquisition required to be done by the owner of the fuel station (in sq.m):",
                type: "text",
                dataType: "number",
                showIf: {
                  field: 135,
                  value: "Yes",
                },
              },
            ],
          },
          {
            id: 291,
            name: 291,
            title:
              "Whether additional land acquisition as above, required by the side of the ROW (to provide the prescribed turning radius), has been done by the owner of the fuel station? ",
            type: "radio",
            options: ["Yes", "No"],
            alwaysShowNested: true,
            nestedFields: [
              {
                id: 138,
                name: 138,
                title:
                  "Whether the documentary evidence of the land acquisition details is attached?",
                type: "radio",
                options: ["Yes", "No"],
                showIf: {
                  field: 291,
                  value: "Yes",
                },
              },
            ],
          },
        ],
      },
      {
        id: 17,
        name: 17,
        title:
          "Is the downward slope of the access road towards the fuel station ≥ 2%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the downward slope of the access road (in %).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
      {
        id: 18,
        name: 18,
        title:
          "Difference in level between the highway and the fuel station and access area measured at the edge of the shoulder on the highway (minimum 300 mm)?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "nh_access_area_diff",
            title:
              "Please specify the vertical difference between NH and access area (in mm).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Other Technical & Documentation Compliance",
    fields: [
      {
        id: 19,
        name: 19,
        title: "Is a culvert provided and designed as per IRC:SP-13?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 292,
        name: 292,
        title: "Provision of drinking water and toilet facilities?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 293,
        name: 293,
        title:
          "Provision of proper drainage arrangement for fuel station premises?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 20,
        name: 20,
        title:
          "Are adequate signs, markings, and display boards provided as per approved drawings?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 21,
        name: 21,
        title:
          "Whether the oil company has certified that the fuel station is not operational or energized and that construction has not commenced?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 313,
        name: 313,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
    ],
  },
];

export const ifRuralSectionRetailNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 70,
        name: 70,
        title: "Is the length of the acceleration lane at least 100 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "acceleration_length",
            title: "Please specify the acceleration lane length (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 100,
            },
          },
        ],
      },
      {
        id: 71,
        name: 71,
        title: "Is the length of the deceleration lane at least 70 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "deceleration_length",
            title: "Please specify the deceleration lane length (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 70,
            },
          },
        ],
      },
      {
        id: 96,
        name: 96,
        title:
          "Is the distance from the nearest intersection (any category of road / median gap) at least 300 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "nearest_intersection_length",
            title:
              "Please specify the nearest intersection length (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 73,
        name: 73,
        title:
          "Is the distance from the nearest toll plaza, railway level crossing, or check barrier at least 1000 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_toll_plaza",
            title:
              "Please specify the distance from the toll plaza (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1000,
              // message: "Distance must be at least 1000 metres",
            },
          },
        ],
      },
      {
        id: 74,
        name: 74,
        title:
          "Is the distance from the start of the Road Over Bridge ≥ 200 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_start_rob",
            title:
              "Please specify the distance from the start of the ROB (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 200,
              // message: "Distance must be at least 200 metres",
            },
          },
        ],
      },
      {
        id: 75,
        name: 75,
        title:
          "Is the distance from the start of the grade separator / flyover at least 300 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "start_distance_from_flyover",
            title:
              "Please specify the start distance from the flyover (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
    ],
  },
  {
    title: "Provision of Service Road / Connecting Road",
    fields: [
      {
        name: "fuel_station_carriageway_type",
        title:
          "Nature of Carriageway",
        type: "radio",
        options: [
          { id: "Yes", name: "Undivided carriageway" },
          { id: "No", name: "Divided carriageway" },
        ],
      },
      {
        id: 78,
        name: 78,
        title:
          "Whether distance from nearest Fuel Station Undivided carriageway is 300 m (for both side of carriageway)? Note: However, this restriction shall not apply in case access / egress for all such fuel stations are provided through common service road of 7.0 m width and not directly through NH. Further, access for fuel stations at closer proximity than 300 m may be allowed provided entry / exit for both the fuel stations are provided through a service road of 7.0 m width having sufficient length; further, additional length of such service road shall be constructed at the cost of the latter fuel station owner / company seeking grant of permission for access for the facility.",
        type: "radio",
        options: ["Yes", "No"],
        showIf: {
          field: "fuel_station_carriageway_type",
          value: "Yes",
        },
        nestedFields: [
          {
            name: "undivided_carriageway_distance_from_fs",
            title:
              "Please specify the undivided carriageway distance from fuel station (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 399,
        name: 399,
        title:
          "Whether distance from nearest Fuel Station Divided carriageway is 1000 m (with no gap in median at this location)? Note: However, this restriction shall not apply in case access / egress for all such fuel stations are provided through common service road of 7.0 m width and not directly through NH. Further, access for fuel stations at closer proximity than 1000 m may be allowed provided entry / exit for both the fuel stations are provided through a service road of 7.0 m width having sufficient length; further, additional length of such service road shall be constructed at the cost of the latter fuel station owner / company seeking grant of permission for access for the facility.",
        type: "radio",
        options: ["Yes", "No"],
        showIf: {
          field: "fuel_station_carriageway_type",
          value: "No",
        },
        nestedFields: [
          {
            name: "divided_carriageway_distance_from_fs",
            title:
              "Please specify the divided carriageway distance from fuel station (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1000,
            },
          },
        ],
      },
      {
        id: 79,
        name: 79,
        title:
          "Is there a provision of a service/connecting road provided near the property (necessary at clustering of retail outlets/intersections with any category of road less than 300/1000 m)?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_provision_length",
            title:
              "Length of the service road including deceleration and acceleration lanes (in metres).",
            type: "text",
            dataType: "number",
          },
          {
            name: "service_road_length",
            title: "Mention the extent of land acquisition required (in sq.m).",
            type: "text",
            dataType: "number",
          },
          {
            id: 294,
            name: 294,
            title:
              "Whether additional land acquisition is required for service road/turning radius?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                name: "land_acquired_extent",
                title:
                  "Mention the extent of land acquisition required (in sq.m):",
                type: "text",
                dataType: "number",
                showIf: {
                  field: 294,
                  value: "Yes",
                },
              },
            ],
          },
          {
            id: 295,
            name: 295,
            title:
              "Whether additional land acquisition as above has been done by the oil company?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                id: 296,
                name: 296,
                title:
                  "Whether documentary evidence of land acquisition details is attached?",
                type: "radio",
                options: ["Yes", "No"],
                showIf: {
                  field: 295,
                  value: "Yes",
                },
              },
            ],
          },
        ],
      },
    ],
  },

  /////////////////////////
  {
    title: "Gradient, Slope & Level Requirements",
    fields: [
      {
        id: 80,
        name: 80,
        title: "Is the highway section gradient ≤ 5%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "highway_gradient_percent",
            title: "Please specify the highway gradient (in %).",
            type: "text",
            dataType: "number",
            validation: {
              max: 5,
            },
          },
        ],
      },
      {
        id: 81,
        name: 81,
        title:
          "Is the slope of the fuel station premises/service area for drainage purposes ≥ 2%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "slope_premise_percent",
            title: "Please specify the slope of the premises (in %).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Plot Specification and Plot Geometrics",
    fields: [
      {
        id: 84,
        name: 84,
        title: "Is the buffer strip length ≥ 12 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "buffer_strip_length",
            title: "Please specify the buffer strip length (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 12,
            },
          },
        ],
      },
      {
        id: 85,
        name: 85,
        title: "Is the buffer strip width (within ROW) ≥ 3 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "buffer_strip_width",
            title: "Please specify the buffer strip width (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 3,
            },
          },
        ],
      },
      {
        id: 86,
        name: 86,
        title: "Is the kerb height ≥ 275 mm?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "kerb_height",
            title: "Please specify the kerb height (in mm).",
            type: "text",
            dataType: "number",
            validation: {
              min: 275,
            },
          },
        ],
      },
      {
        id: 87,
        name: 87,
        title: "Is the turning radius ≥ 13 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "turning_curve_radius",
            title: "Please specify the turning curve radius (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 88,
        name: 88,
        title: "Is the non-turning radius between 1.5 metres and 3 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the non-turning curve radius (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
          {
            id: 99,
            name: 99,
            title:
              "Whether additional land acquisition is required by the side of the ROW (to provide the prescribed turning radius) by the owner of the fuel station?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                name: "area_acquired",
                title:
                  "Mention the additional land acquisition required to be done by the owner of the fuel station (in sq.m).",
                type: "text",
                dataType: "number",
                showIf: {
                  field: 99,
                  value: "Yes",
                },
              },
            ],
          },
          {
            id: 101,
            name: 101,
            title:
              "Whether additional land acquisition as above, required by the side of the ROW (to provide the prescribed turning radius), has been done by the owner of the fuel station?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                id: 102,
                name: 102,
                title:
                  "Whether the documentary evidence of the land acquisition details is attached?",
                type: "radio",
                options: ["Yes", "No"],
                showIf: {
                  field: 101,
                  value: "Yes",
                },
              },
            ],
          },
        ],
      },
      {
        id: 89,
        name: 89,
        title:
          "Is the downward slope of the access road towards the fuel station ≥ 2%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "access_road_downward_slope",
            title:
              "Please specify the downward slope of the access road (in %).",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },

  {
    title: "Details of Drainage.",
    fields: [
      {
        id: 90,
        name: 90,
        title:
          "Difference in level between the highway and the fuel station and access area measured at the edge of the shoulder on the highway (minimum 300 mm)?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "nh_access_area_diff",
            title:
              "Please specify the height difference between NH and access area (in mm).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 91,
        name: 91,
        title: "Is a culvert provided and designed per IRC:SP-13?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 93,
        name: 93,
        title: "Is drainage provision adequate?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 297,
        name: 297,
        title: "Provision of drinking water and toilet facilities: ",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 92,
        name: 92,
        title: "Are signs, boards, and markings in place as per design?",
        type: "radio",
        options: ["Yes", "No"],
      },

      // {
      //   id: 146,
      //   name: 146,
      //   title:
      //     "Whether the oil company has certified that the fuel station is not operational or energized and that construction has not commenced",
      //   type: "radio",
      //   options: ["Yes", "No"]
      // },
      {
        id: 314,
        name: 314,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
    ],
  },
];

export const ifHillySectionRetailNew: Section[] = [
  {
    title: "Distance & Norms",
    fields: [
      {
        id: 24,
        name: 24,
        title:
          "Is the distance from the nearest intersection (any category / road median gap) at least 100 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_nearest_intersection",
            title:
              "Please specify the distance from the nearest intersection (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 100,
            },
          },
        ],
      },
      {
        id: 298,
        name: 298,
        title:
          "Is the distance from the nearest toll plaza, railway level crossing, or check barrier at least 1000 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_toll_plaza",
            title:
              "Please specify the distance from the nearest toll plaza, railway level crossing, or check barrier (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1000,
              // message: "Distance must be at least 1000 metres",
            },
          },
        ],
      },
      {
        id: 25,
        name: 25,
        title:
          "Is the distance from the start of the Road Over Bridge (ROB) at least 200 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "distance_from_start_rob",
            title:
              "Please specify the distance from the start of the Road Over Bridge (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 200,
              // message: "Distance must be at least 200 metres",
            },
          },
        ],
      },
      {
        id: 26,
        name: 26,
        title:
          "Is the distance from the start of the flyover / grade separator at least 300 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "start_distance_from_flyover",
            title:
              "Please specify the distance from the start of the flyover / grade separator (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
              // message: "Distance must be at least 300 metres",
            },
          },
        ],
      },
      {
        name: "fuel_station_carriageway_type",
        title:
          "Nature of Carriageway",
        type: "radio",
        options: [
          { id: "Yes", name: "Undivided Carriageway" },
          { id: "No", name: "Divided Carriageway" },
        ],
      },
      {
        id: 299,
        name: 299,
        title:
          "Distance from nearest Fuel Station Undivided carriageway (for both side of carriageway) is 300 m ? Note: However, this restriction shall not apply in case access / egress for all such fuel stations are provided through common service road of 7.0 m width and not directly through NH. Further, access for fuel stations at closer proximity than 300 m may be allowed provided entry / exit for both the fuel stations are provided through a service road of 7.0 m width having sufficient length; further, additional length of such service road shall be constructed at the cost of the latter fuel station owner / company seeking grant of permission for access for the facility. ",
        type: "radio",
        options: ["Yes", "No"],
        showIf: {
          field: "fuel_station_carriageway_type",
          value: "Yes",
        },
        nestedFields: [
          {
            title:
              "Please specify the undivided carriageway distance from fuel station (in metres).",
            name: "carriageway_fs_distance",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 433,
        name: 433,
        title:
          "Distance from nearest Fuel Station Divided carriageway (with no gap in median at this location) is 300 m ? Note: However, this restriction shall not apply in case access / egress for all such fuel stations are provided through common service road of 7.0 m width and not directly through NH. Further, access for fuel stations at closer proximity than 300 m may be allowed provided entry / exit for both the fuel stations are provided through a service road of 7.0 m width having sufficient length; further, additional length of such service road shall be constructed at the cost of the latter fuel station owner / company seeking grant of permission for access for the facility.",
        type: "radio",
        options: ["Yes", "No"],
        showIf: {
          field: "fuel_station_carriageway_type",
          value: "No",
        },
        nestedFields: [
          {
            title:
              "Please specify the divided carriageway distance from fuel station (in metres).",
            name: "divided_carriageway_distance_from_fs",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 29,
        name: 29,
        title:
          "Is there a provision of a service/connecting road provided near the property (necessary at clustering of retail outlets/intersections with any category of road less than 300 m)?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "service_road_length",
            title:
              "What is the length of the service road including deceleration and acceleration lanes (in metres)?",
            type: "text",
            dataType: "number",
          },
          {
            id: 31,
            name: 31,
            title:
              "Whether additional land acquisition is required for service road/turning radius? ",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                name: "land_acquired_extent",
                title:
                  "Mention the extent of land acquisition required (in sq.m):",
                type: "text",
                dataType: "number",
                showIf: {
                  field: 31,
                  value: "Yes",
                },
              },
              {
                id: 32,
                name: 32,
                title:
                  "Whether additional land acquisition as above has been done by the oil company?",
                type: "radio",
                options: ["Yes", "No"],
                nestedFields: [
                  {
                    id: 33,
                    name: 33,
                    title:
                      "Whether documentary evidence of land acquisition details is attached?",
                    type: "radio",
                    options: ["Yes", "No"],
                    showIf: {
                      field: 32,
                      value: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Road Gradient & Site Level Compliance",
    fields: [
      {
        id: 34,
        name: 34,
        title: "Is the gradient of the highway section ≤ 5%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title: "Please specify the gradient of the highway section (in %).",
            name: "highway_gradient_section",
            type: "text",
            dataType: "number",
            validation: {
              max: 5,
            },
          },
        ],
      },
      {
        id: 300,
        name: 300,
        title:
          "Is the slope of the fuel station premises/service area for drainage purposes ≥ 2%? ",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title:
              "Please specify the downward slope of the access road (in %).",
            name: "fuel_station_slope_percentage",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Buffer Strip & Road Elements",
    fields: [
      {
        id: 35,
        name: 35,
        title: "Is the length of the buffer strip ≥ 5 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title: "Please specify the buffer strip length (in metres).",
            name: "buffer_strip_length",
            type: "text",
            dataType: "number",
            validation: {
              min: 5,
            },
          },
        ],
      },
      {
        id: 36,
        name: 36,
        title: "Is the width of the buffer strip inside the ROW ≥ 3 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title: "Please specify the buffer strip width (in metres).",
            name: "buffer_strip_width",
            type: "text",
            dataType: "number",
            validation: {
              min: 3,
            },
          },
        ],
      },
      {
        id: 37,
        name: 37,
        title: "Is the height of the kerb ≥ 275 mm?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title: "Please specify the kerb height (in mm).",
            name: "kerb_height",
            type: "text",
            dataType: "number",
            validation: {
              min: 275,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Turning Radius & Land Acquisition",
    fields: [
      {
        id: 38,
        name: 38,
        title: "Is the radius of the turning curve ≥ 13 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title: "Please specify the turning curve radius (in metres).",
            name: "turning_curve_radius",
            type: "text",
            dataType: "number",
            validation: {
              min: 13,
            },
          },
        ],
      },
      {
        id: 39,
        name: 39,
        title:
          "Is the radius of the non-turning curve between 1.5 metres and 3 metres?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "non_turning_curve_radius",
            title: "Please specify the non-turning curve radius (in metres).",
            type: "text",
            dataType: "number",
            validation: {
              min: 1.5,
              max: 3,
            },
          },
          {
            id: 136,
            name: 136,
            title:
              "Whether land acquisition is required by the side of the ROW (to provide the prescribed turning radius) by the owner of the fuel station?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                name: "area_acquired",
                title:
                  "Mention additional land acquisition required to be done by the owner of the fuel station (in sq.m):",
                type: "text",
                dataType: "number",
                // showIf: {
                //   field: 136,
                //   value: "Yes",
                // },
              },
            ],
          },
          {
            id: 132,
            name: 132,
            title:
              "Whether additional land acquisition as above, required by the side of the ROW (to provide the prescribed turning radius), has been done by the owner of the fuel station?",
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                id: 139,
                name: 139,
                title:
                  "Whether the documentary evidence of the land acquisition details is attached?",
                type: "radio",
                options: ["Yes", "No"],
                showIf: {
                  field: 132,
                  value: "Yes",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Infrastructure & Utilities",
    fields: [
      {
        id: 40,
        name: 40,
        title:
          "Is the downward slope of the access road towards the fuel station property ≥ 2%?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title:
              "Please specify the downward slope of the access road (in %).",
            name: "access_road_downward_slope",
            type: "text",
            dataType: "number",
            validation: {
              min: 2,
            },
          },
        ],
      },
      {
        id: 41,
        name: 41,
        title:
          "Difference in level between the highway and the fuel station and access area measured at the edge of the shoulder on the highway (minimum 300 mm)?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            title:
              "Please specify the vertical difference between NH and access area (in mm).",
            name: "nh_access_area_diff",
            type: "text",
            dataType: "number",
            validation: {
              min: 300,
            },
          },
        ],
      },
      {
        id: 42,
        name: 42,
        title: "Is a culvert provided and designed as per IRC:SP-13?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 302,
        name: 302,
        title: "Provision of drinking water and toilet facilities",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 303,
        name: 303,
        title:
          "Provision of proper drainage arrangement for fuel station premises",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 43,
        name: 43,
        title:
          "Are adequate signs, markings, and display boards provided as per approved drawings?",
        type: "radio",
        options: ["Yes", "No"],
      },
    ],
  },
  {
    title: "Certification & Documentation",
    fields: [
      {
        id: 44,
        name: 44,
        title:
          "Has the oil company certified that the fuel station is not energized, not operational, and construction has not commenced? ",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        id: 315,
        name: 315,
        title:
          "Are any culverts or cross-drainage structures required to be widened or augmented?",
        type: "radio",
        options: ["Yes", "No"],
        alwaysShowNested: true,
        nestedFields: [
          {
            name: "num_of_cultivates",
            title:
              "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
            type: "text",
            dataType: "number",
          },
        ],
      },
    ],
  },
];
